/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Check_Resume_DraftInputs */

const en_directory_submit_check_resume_draft = /** @type {(inputs: Directory_Submit_Check_Resume_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume draft`)
};

const zh_directory_submit_check_resume_draft = /** @type {(inputs: Directory_Submit_Check_Resume_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续草稿`)
};

/**
* | output |
* | --- |
* | "Resume draft" |
*
* @param {Directory_Submit_Check_Resume_DraftInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_check_resume_draft = /** @type {((inputs?: Directory_Submit_Check_Resume_DraftInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Check_Resume_DraftInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_check_resume_draft(inputs)
	return zh_directory_submit_check_resume_draft(inputs)
});
export { directory_submit_check_resume_draft as "directory.submit.check.resume_draft" }